import { ShieldAlert } from 'lucide-react';
import { buttonClass } from '../../components/buttonClass.ts';
import { PublicLayout } from '../authorization/PublicLayout.tsx';
import { useSession } from '../../state/session.ts';
import styles from './WorkspaceAccessDenied.module.css';

interface WorkspaceAccessDeniedProps {
  workspaceId?: string;
  message?: string;
}

export function WorkspaceAccessDenied({
  workspaceId,
  message = 'Workspace access required',
}: WorkspaceAccessDeniedProps) {
  const actor = useSession((s) => s.actor);

  return (
    <PublicLayout title="Workspace access denied">
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.iconWrap} aria-hidden="true">
            <ShieldAlert size={28} />
          </div>
          <div className={styles.headingGroup}>
            <h2 className={styles.title}>Access restricted</h2>
            <p className={styles.subtitle}>You do not have active membership in this workspace.</p>
          </div>
        </div>

        <div className={styles.alertBox} role="alert">
          <p className={styles.alertText}>
            {message}. Tenant boundaries in Traceira are strictly enforced: workspace access is
            restricted to confirmed owners and authorized members.
          </p>
          <dl className={styles.metaList}>
            {workspaceId && (
              <>
                <dt className={styles.metaLabel}>Workspace ID</dt>
                <dd className={styles.metaValue}>{workspaceId}</dd>
              </>
            )}
            {actor?.email && (
              <>
                <dt className={styles.metaLabel}>Authenticated as</dt>
                <dd className={styles.metaValue}>{actor.email}</dd>
              </>
            )}
          </dl>
        </div>

        <div className={styles.actions}>
          <a href="/workspaces" className={buttonClass('primary')}>
            View your workspaces
          </a>
          <a href="/sign-in" className={buttonClass('secondary')}>
            Sign in as different user
          </a>
          <a href="/setup?step=1" className={buttonClass('tertiary')}>
            Set up a new workspace
          </a>
        </div>
      </div>
    </PublicLayout>
  );
}
